import { memo, useState, useEffect, useCallback, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { HashLink } from 'react-router-hash-link';
import headerImg from "../assets/img/header-img.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = memo(() => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 2000;

  const toRotate = useMemo(() => ["Creator", "Engineer"], []);

  const tick = useCallback(() => {
    const i = loopNum % toRotate.length;
    const fullText = toRotate[i];
    const updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prev) => prev / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  }, [isDeleting, loopNum, text, toRotate]);

  useEffect(() => {
    const ticker = setInterval(() => {
      tick();
    }, delta);

    return () => clearInterval(ticker);
  }, [text, delta, tick]);

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <meta
          name="description"
          content="Özkan Kizilkan: Berlin-based Developer specializing in modern web applications, clean UI design, scalable backend systems, cloud platforms, and machine learning solutions."
        />
        <meta
          name="keywords"
          content="Özkan Kizilkan, developer berlin, full-stack developer, react, node.js, machine learning, cloud, medieninformatik"
        />
        <meta property="og:title" content="Özkan Kizilkan" />
        <meta
          property="og:description"
          content="Özkan Kizilkan'ın portföy sitesine hoş geldiniz. Modern web uygulamaları, makine öğrenimi ve bulut çözümleri."
        />
        <meta property="og:url" content="https://www.kizilkandev.de" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Özkan Kizilkan",
            "jobTitle": "Software Developer",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Berlin, Germany"
            },
            "url": "https://www.kizilkandev.de",
            "sameAs": [
              "https://github.com/kzkln",
              "https://www.linkedin.com/in/%C3%B6zkan-kizilkan-456054180/"
            ]
          })}
        </script>
      </Helmet>

      {/* Asıl Banner Bölümü */}
      <section className="banner" id="home">
        <Container>
          <Row className="align-items-center flex-column-reverse flex-md-row">
            <Col xs={12} md={6} xl={7}>
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                    <h1 className="banner-title">
                      Hi, I’m Özkan <span className="typed-text">{text}</span>
                    </h1>
                    <div className="professional-summary">
                      <p>
                        I'm a <span className="keyword">developer</span> based in Berlin with a background in <span className="keyword">Medieninformatik</span>. 
                        I specialize in building <span className="keyword">modern web applications</span>, designing clean user interfaces, and architecting 
                        <span className="keyword"> scalable backend systems</span>. I also work with <span className="keyword">cloud platforms</span> and develop 
                        <span className="keyword"> machine learning solutions</span> that solve real-world problems. With a strong balance of 
                        <span className="keyword"> technical depth</span> and <span className="keyword">design thinking</span>, I focus on delivering 
                        <span className="keyword"> clean, efficient, and maintainable code</span>.
                      </p>

                      <HashLink smooth to="/#connect" className="hash-link">
  <button className="vvd">
    <span>Let’s Connect</span>
  </button>
</HashLink>

                    </div>
                  </div>
                )}
              </TrackVisibility>
            </Col>

            <Col xs={12} md={6} xl={5} className="text-center mb-4 mb-md-0">
              <TrackVisibility>
                {({ isVisible }) => (
                  <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img
                      src={headerImg}
                      alt="Header"
                      style={{ maxWidth: "100%", height: "auto" }}
                      loading="lazy"
                    />
                  </div>
                )}
              </TrackVisibility>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
});
